import { AlarmClock, QrCode, Instagram } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { OutletCard } from "../components/OutletCard";
import { CtaBanner } from "../sections/CtaBanner";
import { LOCATIONS, HOURS_NOTE, SITE } from "../data/site";

const tips = [
  {
    icon: AlarmClock,
    title: "Datang lebih awal",
    text: "Antrean paling panjang biasanya saat jam makan siang dan makan malam. Datang lebih awal supaya tidak menunggu lama atau kehabisan.",
  },
  {
    icon: QrCode,
    title: "Manfaatkan antrean QR",
    text: "Di outlet Melawai, antrean memakai sistem digital. Pindai kode QR di lokasi, ambil nomor, lalu pantau posisi antreanmu dari ponsel.",
  },
  {
    icon: Instagram,
    title: "Cek info terbaru",
    text: "Perubahan jam operasional, stok habis, atau pengumuman lain selalu diinfokan duluan di Instagram resmi @agb.buiyin.",
  },
];

export default function LokasiPage() {
  return (
    <div data-testid="lokasi-page">
      <PageHero
        eyebrow="Lokasi & Jam Buka"
        title="Dua titik buat memuaskan ngidammu."
        description="Mampir ke outlet open space kami di Melawai, Jakarta Selatan, atau ke kios pertama di Fresh Market Emerald Bintaro, Tangerang Selatan."
        crumbs={[
          { label: "Beranda", href: "/" },
          { label: "Lokasi", href: "/lokasi/" },
        ]}
      />

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-20" aria-label="Daftar outlet">
        <div className="grid gap-8 md:grid-cols-2">
          {LOCATIONS.map((loc) => (
            <OutletCard key={loc.id} location={loc} detailed />
          ))}
        </div>
        <p className="mt-8 text-center text-xs leading-relaxed text-charcoal-muted">
          {HOURS_NOTE}
        </p>
      </section>

      <section className="bg-canvas-subtle py-16 sm:py-20" aria-label="Tips berkunjung">
        <div className="mx-auto max-w-6xl px-5">
          <h2 className="font-heading text-2xl font-extrabold tracking-tight text-charcoal sm:text-3xl">
            Tips anti kehabisan.
          </h2>
          <div className="mt-10 grid gap-6 sm:grid-cols-3">
            {tips.map((tip) => (
              <div
                key={tip.title}
                className="rounded-lg border border-amber-900/15 bg-white p-6 transition-transform duration-200 hover:-translate-y-1"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-bumbu-light text-bumbu-deep">
                  <tip.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-charcoal">
                  {tip.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-charcoal-muted">
                  {tip.text}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 flex flex-col items-center justify-between gap-5 rounded-lg bg-goang-light px-6 py-7 sm:flex-row sm:px-8">
            <p className="text-center font-heading text-lg font-bold text-goang-deep sm:text-left">
              Malas antre? Outlet Melawai bisa dipesan lewat GrabFood.
            </p>
            <a
              href={SITE.grabfood}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="lokasi-grabfood-button"
              className="shrink-0 rounded-full bg-goang px-7 py-3 font-heading text-sm font-bold text-white transition-all hover:scale-[1.03] hover:bg-goang-deep active:scale-[0.98]"
            >
              Buka GrabFood
            </a>
          </div>
        </div>
      </section>

      <CtaBanner />
    </div>
  );
}
